/**
 * TopBar — Back button + title + right actions
 *
 * Used for: screen headers on detail/settings pages
 */
import type { ReactNode } from 'react'
import { Platform } from 'react-native'
import { styled, XStack, YStack, Text as TamaguiText, type GetProps } from 'tamagui'

const TopBarFrame = styled(XStack, {
  name: 'TopBar',
  ai: 'center',
  jc: 'space-between',
  px: '$sm',
  pb: '$xs',
  pt: Platform.OS === 'web' ? '$sm' : '$2xl',
  bg: 'transparent',
})

const TopBarTitle = styled(TamaguiText, {
  name: 'TopBarTitle',
  fontFamily: '$heading',
  fontSize: 20,
  fontWeight: '700',
  color: '$color',
  f: 1,
  textAlign: 'center',
})

type TopBarFrameProps = GetProps<typeof TopBarFrame>

interface TopBarProps extends TopBarFrameProps {
  title: string
  left?: ReactNode
  right?: ReactNode
}

export const TopBar = TopBarFrame.styleable<TopBarProps>(
  ({ title, left, right, ...props }, ref) => {
    return (
      <TopBarFrame ref={ref} {...props}>
        <XStack w={48} ai="center">
          {left}
        </XStack>
        <TopBarTitle numberOfLines={1}>{title}</TopBarTitle>
        <XStack w={48} ai="center" jc="flex-end">
          {right}
        </XStack>
      </TopBarFrame>
    )
  },
)
